import { useState } from "react";
import { Modal } from "react-bootstrap";
import { RxCross1 } from "react-icons/rx";
import PayLinkCheckoutModalForm from "./PayLinkCheckoutModalForm";
import PayLinkCheckoutModalMobileVerification from "./PayLinkCheckoutModalMobileVerification";

export default function PayLinkCheckoutModal({ onClose, onSubmit, isPending }) {
  const [step, setStep] = useState(1);
  const [body, setBody] = useState(null);

  return (
    <Modal show centered size="lg">
      <Modal.Header className="d-flex justify-content-between align-items-center">
        <h6 className="mb-0">لطفا اطلاعات مربوطه را تکمیل نمایید</h6>

        <button className="buttonUi" onClick={onClose}>
          <RxCross1 size="22" />
        </button>
      </Modal.Header>

      <Modal.Body style={{ minHeight: 240 }}>
        <PayLinkCheckoutModalForm
          display={step === 1 ? "d-block" : "d-none"}
          onSubmit={values => {
            setStep(2);
            setBody(values);
          }}
        />

        <PayLinkCheckoutModalMobileVerification
          display={step === 2 ? "d-block" : "d-none"}
          body={body}
          isPending={isPending}
          onSubmit={values => onSubmit({ ...body, ...values })}
          onPrev={() => setStep(1)}
        />
      </Modal.Body>
    </Modal>
  );
}
